import { Action } from '@ngrx/store';
import { IRaceResult} from '../../models/raceresult';

export enum ERaceResultActions {
    GetRaceResult = '[RaceResult] Get RaceResult',
    GetRaceResultSuccess = '[RaceResult] Get Race Result Success'
}

export class GetResultRace implements Action {
    public readonly type = ERaceResultActions.GetRaceResult;
}

export class GetRaceResultSuccess implements Action {
    public readonly type = ERaceResultActions.GetRaceResultSuccess;
    constructor(public payload: IRaceResult) {}
}

export type RaceResultActions =
    | GetResultRace
    | GetRaceResultSuccess;
